import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataValue } from 'Simple/Data.js'
import React, { useEffect } from 'react'
import View from './view.js'

export default function Logic(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let tab = useDataValue({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let value = useDataValue({
    context: 'global',
    path: 'acknowledged_notifications_by_patient',
    viewPath: props.viewPath,
  })
  useEffect(() => {
    // Tab change means that the notifications modal is closed
    // If acknowledged was not clicked, open the modal again
    if (!value?.includes(tab?.patient_id)) {
      setFlowTo(normalizePath(props.viewPath, 'Content'))
    }
  }, [tab, value]) // eslint-disable-line
  // ignore submit

  return <View {...props} />
}
